// Header.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const navigate = useNavigate();

  // Función que redirige a la ruta del dashboard
  const handleLogoClick = () => {
    // Si quieres que vaya a "/dashboard" o "/dashboard?page=Ventas" depende de tu implementación
    navigate("/dashboard?page=Ventas");
  };

  return (
    <header className="login-header">
      <div className="header-content">
        <div className="header-left">
          <h1>Ventas Canal ISP</h1>
        </div>
        <div className="header-right">
          {/* Envolvemos el logo en un button (o un div con onClick) */}
          <button
            type="button"
            className="header-logo-button"
            onClick={handleLogoClick}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            <img
              src="/images/logo-fondomorado.png"
              alt="Logo"
              className="header-logo"
            />
          </button>
          <span className="header-ingbell">Ingbell Chile SpA.</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
